import { render } from "./RecaptchaPolicyHintView.vue?vue&type=template&id=1236b82c&scoped=true"
import script from "./RecaptchaPolicyHintView.vue?vue&type=script&lang=js"
export * from "./RecaptchaPolicyHintView.vue?vue&type=script&lang=js"

import "./RecaptchaPolicyHintView.vue?vue&type=style&index=0&id=1236b82c&scoped=true&lang=less"

import exportComponent from "/Users/kacper/IdeaProjects/e.on-portal-awarie/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1236b82c"]])

export default __exports__